import { motion } from "framer-motion";
import { Phone, Calendar, Droplets, Sparkles } from "lucide-react";

const steps = [
    {
        icon: Phone,
        n: "01",
        title: "Call or Text",
        desc: "Tell us what needs cleaning — we'll send a same-day estimate.",
    },
    {
        icon: Calendar,
        n: "02",
        title: "Schedule",
        desc: "Pick a time that works for you. Evenings and weekends available.",
    },
    {
        icon: Droplets,
        n: "03",
        title: "We Clean",
        desc: "Pro-grade equipment, safe chemistry, careful around landscaping.",
    },
    {
        icon: Sparkles,
        n: "04",
        title: "You Love It",
        desc: "100% satisfaction guarantee — or we come back and make it right.",
    },
];

export default function Process() {
    return (
        <section
            data-testid="process-section"
            className="relative py-24 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="mb-16 max-w-2xl">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#1E88E5] font-bold mb-4">
                        / How It Works
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a0a0a]">
                        Four steps from
                        <br />
                        <span className="text-[#1E88E5]">grime to gleam.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {steps.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.n}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                                className="relative bg-white border border-black/10 hover:border-[#1E88E5]/40 hover:shadow-lg p-8 rounded-sm transition-all"
                                data-testid={`process-step-${i}`}
                            >
                                <div className="absolute top-6 right-6 font-display font-bold text-5xl text-black/[0.06]">
                                    {s.n}
                                </div>
                                <div className="w-11 h-11 bg-[#1E88E5] flex items-center justify-center rounded-sm mb-6">
                                    <Icon className="w-5 h-5 text-white" />
                                </div>
                                <h3 className="font-display font-bold uppercase text-xl mb-2 text-[#0a0a0a]">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-gray-600 leading-relaxed">
                                    {s.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
